import { render, staticRenderFns } from "./spotter.vue?vue&type=template&id=0dc2f60a&"
import script from "./spotter.vue?vue&type=script&lang=js&"
export * from "./spotter.vue?vue&type=script&lang=js&"
import style0 from "./spotter.vue?vue&type=style&index=0&id=0dc2f60a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports